"use client"

import { useEffect, useRef } from "react";

function CookieDeclaration() {
  const domainGroupId = '6cbb1ca4-82e5-4793-8787-88dfbd53a894';
  const divRef = useRef(null);
  const scriptId = `CookieDeclaration`;

  useEffect(() => {
    let script = document.getElementById(scriptId);
    if (script) {
      return;
    }
    script = document.createElement(`script`);
    script.id = scriptId;
    script.setAttribute(`src`, `https://consent.cookiebot.com/${ domainGroupId }/cd.js`);
    script.setAttribute(`type`, `text/javascript`);
    script.setAttribute(`async`, `true`);

    if (divRef.current) {
      divRef.current.appendChild(script);
    }
  }, [domainGroupId, scriptId]);

  return <div ref={ divRef }/>;
}

export default CookieDeclaration;